module.exports = __webpack_public_path__ + "img/math-5-en.222cee38.png";